<template>
  <div
    id="app"
    class="app"
    :class="[
      browserAsCSSClass,
      {
        'touch-events': touchScreen,
        'no-touch-events': !touchScreen,
        'with-motion': !settings.reducedMotion,
      },
    ]"
    @mousemove="interactionDetected('long', true)"
    @mouseleave="onMouseLeave"
  >
  <router-view />
  <full-page :options="options" id="fullpage">
    <div class="section">

    <fullscreen ref="fullscreen" :fullscreen.sync="fullscreen">
      <!-- <div class="flex justify-center items-center absolute w-2/3 h-20 border-2 border-white"></div> -->
      <TheBackground
        :controlsAreVisible="controlsAreVisible"
        :keyboardInputIsVisible="TheTimerKeyboardInputIsVisible"
        :timeIsAlmostUp="timeIsAlmostUp"
        :isCountingUp="isCountingUp"
        :settingReducedMotion="settings.reducedMotion"
      >
      <!-- <div class="w-2/3 h-20 border-2 border-white flex justify-center items-center absolute"></div> -->
        <div
          class="main-container"
          :class="[
            {
              subdued:
                visibleTray || TheSplashIsVisible || TheScreenSaverIsVisible,
              'with-intro-transition': preparingTheTimerUI,
            },
          ]"
          @transitionend="preparingTheTimerUI = false"
        >
          <routerView
            name="main"
            v-cloak
            :handleKeyboard="!TheSplashIsVisible"
            :settings="settings"
            :settingRepeat.sync="settings.repeat"
            :settingWarnWhenTimeIsAlmostUp="settings.warnWhenTimeIsAlmostUp"
            :settingContinueBeyondZero="settings.continueBeyondZero"
            :repeatDelay="repeatDelay"
            :keyboardInputIsVisible.sync="TheTimerKeyboardInputIsVisible"
            :hoveringOnNotification="hoveringOnNotification"
            :visibleTray="visibleTray"
            :controlsAreVisible.sync="controlsAreVisible"
            :browser="browserName"
            @togglingRunning="states.timerIsRunning = $event"
            @toggleFullscreen="toggleFullscreen"
            @showNotificationRepeatDisabled="showNotificationRepeatDisabled"
            @interactionDetected="interactionDetected"
            @timeIsAlmostUp="timeIsAlmostUp = $event"
            @isCountingUp="isCountingUp = $event"
            @timerIsIdle="cueScreensaver"
          />
          <TheNavigation
            v-if="controlsAreVisible"
            :fullscreen="fullscreen"
            :settingRepeat.sync="settings.repeat"
            :applyWarningColors="timeIsAlmostUp || isCountingUp"
            @toggleFullscreen="toggleFullscreen"
            @showTipFullscreenOnIOS="
              notificationFullscreenOnIOSIsVisible = true
            "
          />
        </div>
        <Modal
          v-if="notificationRepeatDisabledIsVisible && !visibleTray"
          :type="'notification'"
          :title="'Explain that repeat does not work for short durations'"
          :alignment="'top'"
          :autoCloseInterval="4.5"
          :applyWarningColors="timeIsAlmostUp || isCountingUp"
          @autoClose="notificationRepeatDisabledIsVisible = false"
          @close="notificationRepeatDisabledIsVisible = false"
          @closing="notificationRepeatDisabledIsVisible = false"
        >
          <p>
            Repeat only works for durations longer than
            {{ repeatDelay }} seconds.
          </p>
        </Modal>
        <!-- <TheOnboarding
          v-if="
            onboardingCanBeMadeVisible &&
            !states.onboardingComplete &&
            !touchScreen
          "
          :onboardingComplete.sync="states.onboardingComplete"
          :hoveringOnNotification.sync="hoveringOnNotification"
          :timerIsRunning="states.timerIsRunning"
          :controlsAreVisible="controlsAreVisible"
          :applyWarningColors="timeIsAlmostUp || isCountingUp"
          :visibleTray="visibleTray"
          :browser="browserName"
          @close="states.onboardingComplete = true"
        /> -->
        <routerView
          name="tray"
          :settingRepeat="settings.repeat"
          :settingPlayTimerCompleteSound.sync="settings.playTimerCompleteSound"
          :settingPlayTimerCountdownSound.sync="
            settings.playTimerCountdownSound
          "
          :settingWarnWhenTimeIsAlmostUp.sync="settings.warnWhenTimeIsAlmostUp"
          :settingContinueBeyondZero.sync="settings.continueBeyondZero"
          :settingReducedMotion.sync="settings.reducedMotion"
          :settingShowNotifications.sync="settings.showNotifications"
          :browserSupportsPermissionsAPI="browserSupportsPermissionsAPI"
          :visibleTray.sync="visibleTray"
          :applyWarningColors="timeIsAlmostUp || isCountingUp"
        />
        <Modal
          v-if="notificationPermissionIsVisible"
          :type="'notification'"
          :title="'Explanation why notifications are useful'"
          :alignment="'bottom'"
          :withCloseButton="true"
          :hovering.sync="hoveringOnNotification"
          :applyWarningColors="timeIsAlmostUp || isCountingUp"
          @close="notificationPermissionIsVisible = false"
        >
          <p>{{ textNotificationPermission }}</p>
        </Modal>
        <Modal
          v-if="notificationPermissionWhenDeniedIsVisible"
          :type="'notification'"
          :title="'Explanation why notifications are useful, after denial'"
          :alignment="'bottom'"
          :withCloseButton="true"
          :hovering.sync="hoveringOnNotification"
          :applyWarningColors="timeIsAlmostUp || isCountingUp"
          @close="notificationPermissionWhenDeniedIsVisible = false"
        >
          <p>{{ textNotificationPermissionWhenDenied }}</p>
        </Modal>
        <Modal
          v-if="notificationFullscreenOnIOSIsVisible"
          :type="'notification'"
          :title="'How to go fullscreen on iOS'"
          :alignment="'bottom'"
          :withCloseButton="true"
          :hovering.sync="hoveringOnNotification"
          :applyWarningColors="timeIsAlmostUp || isCountingUp"
          @close="notificationFullscreenOnIOSIsVisible = false"
        >
          <p>Add Big Timer to your home screen to go fullscreen.</p>
        </Modal>
        <routerView
          name="splash"
          v-if="TheSplashIsVisible && !visibleTray"
          @close="onCloseSplash"
        />
      </TheBackground>
      <transition name="screensaver">
        <TheScreenSaver
          v-if="TheScreenSaverIsVisible"
          :slideDuration="TheScreenSaverVisibilityDelay"
          @close="onAutoCloseScreenSaver"
        />
      </transition>
    </fullscreen>
    </div>
      <!-- <div class="section">
        <Info/>
      </div> -->
  </full-page>
  </div>
</template>

<script>
import Info from "./components/Info";
import TheBackground from "./components/TheBackground";
import TheTimer from "./components/TheTimer";
import TheOnboarding from "./components/TheOnboarding";
import Modal from "./components/Modal";
import TheNavigation from "./components/TheNavigation";
import TheScreenSaver from "./components/TheScreensaver";


// VueHead updates meta tags in HTML head
import VueHead from "vue-head";
Vue.use(VueHead, {
  separator: "|",
  complement: "Big Timer - Fullscreen countdown timer",
});

// Fullscreen imports
import fullscreen from "vue-fullscreen";
Vue.use(fullscreen);

// Gestures
import vueFinger from "vue-finger";
Vue.use(vueFinger);


import Vue from "vue";

// Create an event bus
Vue.prototype.$bus = new Vue({});

export default {
  name: "App",

  components: {
    TheBackground,
    TheTimer,
    TheOnboarding,
    Modal,
    TheNavigation,
    Info,
    TheScreenSaver,
  },

  data() {
    return {
      options: {
          licenseKey: 'YOUR_KEY_HERE',
          afterLoad: this.afterLoad,
          scrollOverflow: true,
          scrollBar: true,
          menu: '#menu',
          navigation: true,
          anchors: ['timer', '/info'],
          sectionsColor: ['', '#fec401']
        },
      // Configuration
      DEBUG: false,
      showControlsDurationShort: 4500, // Duration for visibility of controls after interaction
      showControlsDurationLong: 10000, // Duration for visibility of controls after interaction
      repeatDelay: 3, // time in seconds between 0:00 and restart

      // Browser & support
      browserName: "",
      touchScreen: false, // Set to true when user touches screen

      // General
      settings: {
        // Is watched and saved to localStorage
        repeat: undefined,
        playTimerCompleteSound: true,
        playTimerCountdownSound: true,
        reducedMotion: true,  // **** TO KEEP REDUCED MOTION TRUE ****
        showNotifications: false,
        warnWhenTimeIsAlmostUp: false,
        continueBeyondZero: false,
      },
      states: {
        // Important states of the applications. Is watched and saved to localStorage
        timerIsRunning: false, // Is the timer running or not?
        onboardingComplete: false, // Has user completed the onboarding?
      },

      // UI
      preparingTheTimerUI: true, // Used for initial animation, is removed when animation is done.
      TheSplashIsVisible: true,
      visibleTray: "", // Can contain the name of the visible tray
      TheTimerKeyboardInputIsVisible: false, // Controls visibility of the form for duration input
      controlsAreVisible: true, // For controlling visibility of controls in sync with that of the controls in TheTimer
      timeIsAlmostUp: false, // Used to change styling when most of the time is up
      isCountingUp: false, // Used to change styling when the time is up
      fullscreen: false, // For making the app fullscreen
      hoveringOnNotification: false, // UI elements are hidden except when this is true.
      TheScreenSaverIsVisible: false,
      TheScreenSaverVisibilityTimeout: null, // Time out to start of screensaver. Only starts after a timer has run.
      TheScreenSaverVisibilityDelay: 120, // Seconds between nothing happening and starting the screensaver.

      // Tips
      firstTimeUse: undefined, // Is this the first time the user loads the app?
      onboardingCanBeMadeVisible: false, // Show/hide notifications with tips
      notificationRepeatDisabledIsVisible: false, // Is shown when user sets a duration too short for repeat.
      notificationPermissionIsVisible: false, // Can load component to request notification permissions
      notificationPermissionWhenDeniedIsVisible: false,
      notificationFullscreenOnIOSIsVisible: false,
      notificationVisibilityTimeout: "", // For debouncing tip
    };
  },

  computed: {
    // Default explanation for the notification permission request
    textNotificationPermission() {
      let browser = "";

      if (this.browserName !== "") {
        browser = this.browserName;
      } else {
        browser = "your browser";
      }
      return (
        "Big Timer can warn you when the timer ends, even if this browser tab is not visible. If you want that, then please allow " +
        browser +
        " to show notifications."
      );
    },

    // Explanation text for when notification permission has been denied.
    textNotificationPermissionWhenDenied() {
      const userAgent = navigator.userAgent;

      if (userAgent.indexOf("Chrome") > -1) {
        return "Please enable notifications in Chrome. Click the lock icon in the address bar to find the notification permission setting.";
      } else if (userAgent.indexOf("Safari") > -1) {
        return "Please enable notifications in Safari. Go to Preferences > Websites > Notifications.";
      } else if (userAgent.indexOf("Opera") > -1) {
        return "Please enable desktop notifications in Opera.";
      } else if (userAgent.indexOf("Firefox") > -1) {
        return "Please enable notifications in Firefox. You'll find that setting when you click the site information icon in the address bar.";
      } else {
        return "Please enable desktop notifications in your browser.";
      }
    },

    browserSupportsPermissionsAPI() {
      // Can the browser show notifications at all?
      const notification =
        window.Notification ||
        window.mozNotification ||
        window.webkitNotification;

      // Does Permissions API expose changes?
      const navPermissions = navigator.permissions;

      // One of the properties can be undefined, so make sure to return true or false only.
      return notification && navPermissions ? true : false;
    },

    browserAsCSSClass() {
      return this.browserName.toLowerCase().replace(/\s/g, "-");
    },
  },

  mounted() {
    this.detectBrowserCapabilities();
    this.optimizeForiOSToolbar();
    this.permissionsChangeListener();
    this.loadLocalData();
  },

  methods: {
    // Browser capability detection for initialization
    //////////////////////////////////////////////////

    detectBrowserCapabilities() {
      this.detectUserAgent();
      this.detectTouch();
      this.detectReducedMotion();
    },

    detectUserAgent() {
      const userAgent = navigator.userAgent;

      // Edge
      if (userAgent.indexOf("Edge/") > -1) {
        this.browserName = "Edge";
      }
      // IE
      else if (userAgent.indexOf("MSIE ") > -1) {
        this.browserName = "IE";
      } else if (userAgent.indexOf("Trident/") > -1) {
        this.browserName = "IE";
      }
      // Chrome
      else if (userAgent.indexOf("Chrome") > -1) {
        this.browserName = "Chrome";
      }
      // Safari
      else if (userAgent.indexOf("Safari") > -1) {
        this.browserName = "Safari";
      }
      // Opera
      else if (userAgent.indexOf("Opera") > -1) {
        this.browserName = "Opera";
      }
      // Firefox
      else if (userAgent.indexOf("Firefox") > -1) {
        this.browserName = "Firefox";
      }
      // Unknown
      else {
        this.browserName = "";
      }
    },

    detectTouch() {
      const that = this;
      window.addEventListener(
        "touchstart",
        function onFirstTouch() {
          that.touchScreen = true;
          window.removeEventListener("touchstart", onFirstTouch, false);
        },
        false
      );
    },

    detectReducedMotion() {
      if (this.settings.reducedMotion === undefined) {
        const motionQuery = matchMedia("(prefers-reduced-motion)");
        this.settings.reducedMotion = motionQuery.matches;
      }
    },

    // Make sure 100vh is 100% of visible viewport, regardless of iOS Safari's toolbars and tabbar.
    optimizeForiOSToolbar() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);

      // Update on changes
      window.addEventListener("resize", () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      });
    },

    // Load previously stored data from local storage
    /////////////////////////////////////////////////

    loadLocalData() {
      const queryRepeatSetting = this.settings.repeat; // Save the setting as set by TheTimer via vue-router, based on URL Query
      this.loadLocalStorage(this.states, "states");
      this.loadLocalStorage(this.settings, "settings");
      if (queryRepeatSetting !== undefined)
        this.settings.repeat = queryRepeatSetting; // The URL query's repeat setting should override the local storage setting, so bookmarks can be used to save that setting.
      if (this.settings.repeat === undefined) this.settings.repeat = false;
    },

    loadLocalStorage(object, localVariable) {
      const loadedObject = JSON.parse(localStorage.getItem(localVariable));

      if (loadedObject && typeof loadedObject === "object") {
        this.firstTimeUse = false;

        for (let item in object) {
          if (loadedObject[item] !== undefined)
            object[item] = loadedObject[item];
        }
      }
    },

    // Showing and hiding components
    ////////////////////////////////

    // Called when cookies are accepted
    onCloseSplash() {
      this.TheSplashIsVisible = false;
      this.onboardingCanBeMadeVisible = true;
    },

    // Called when mouse leaves browser window
    onMouseLeave() {
      this.interactionDetected("short", true);
    },

    // Called on cursor movement and taps: controls autohiding UI elements.
    interactionDetected(duration = "short", showControls = true) {
      this.TheScreenSaverIsVisible = false;
      clearTimeout(this.TheScreenSaverVisibilityTimeout);

      if (duration == "short") {
        duration = this.showControlsDurationShort;
      } else {
        duration = this.showControlsDurationLong;
      }

      this.$nextTick(() => {
        // If the keyboard is used, the controls are not shown, but they don't disappear during use either
        if (showControls && !this.TheTimerKeyboardInputIsVisible) {
          this.controlsAreVisible = true;
        }
      });

      clearTimeout(this.interactionTimeout);
      if (
        !this.TheTimerKeyboardInputIsVisible &&
        !this.hoveringOnNotification &&
        this.visibleTray === ""
      ) {
        this.interactionTimeout = setTimeout(() => {
          if (
            !this.TheSplashIsVisible &&
            !this.TheTimerKeyboardInputIsVisible &&
            !this.hoveringOnNotification &&
            this.visibleTray === ""
          ) {
            if (!this.DEBUG) {
              this.controlsAreVisible = false;
            }
          }
        }, duration);
      }
    },

    cueScreensaver() {
      clearTimeout(this.TheScreenSaverVisibilityTimeout);
      this.TheScreenSaverVisibilityTimeout = setTimeout(() => {
        this.controlsAreVisible = false;
        this.TheScreenSaverIsVisible = true;
      }, this.TheScreenSaverVisibilityDelay * 1000);
    },

    onAutoCloseScreenSaver() {
      this.controlsAreVisible = false;
      this.TheScreenSaverIsVisible = false;
      this.cueScreensaver();
    },

    // Misc
    ///////

    // Enter and exit fullscreen
    toggleFullscreen() {
      this.$refs["fullscreen"].toggle();
      _paq.push(["trackEvent", "Fullscreen", this.fullscreen.toString()]);
    },

    showNotificationRepeatDisabled() {
      this.onboardingCanBeMadeVisible = false;
      this.notificationRepeatDisabledIsVisible = true;
    },

    // Notifications
    ////////////////

    // Did the user allow notifications? Can't be a computed property, as that won't update.
    browserNotificationPermissionStatus() {
      const notification =
        window.Notification ||
        window.mozNotification ||
        window.webkitNotification;
      const permission = notification.permission;

      return notification ? permission : "unknown";
    },

    // Request permission to show browser notifications
    // Argument used to not show tips when permission is requested by manually changing the Show Notifications setting.
    requestNotificationPermission(showTip = true) {
      if (this.browserSupportsPermissionsAPI) {
        // Only show request if it has not been granted yet.
        if (this.browserNotificationPermissionStatus() !== "granted") {
          const notification =
            window.Notification ||
            window.mozNotification ||
            window.webkitNotification;

          // Let the browser show the notification request. Chrome does no longer support this.
          notification.requestPermission();

          if (this.browserNotificationPermissionStatus() === "denied") {
            // Explain why notifications are useful and how to grant them.

            // Most browsers, including previous (but not current) versions of Chrome return "default" when the permission status is not explicitly set by the user.
            // However, Chrome no seems to default to "denied", giving us no clear indication of user preferences. Hence the additional check in

            if (this.settings.showNotifications) {
              this.notificationPermissionWhenDeniedIsVisible = true;
            }
          } else if (showTip) {
            // Explain why notifications are useful, except when user is toggling the setting from the settings tray.
            this.notificationPermissionIsVisible = true;
          }
        }
      }
    },

    // When permissions for notifications change, the UI should respond to that
    permissionsChangeListener() {
      if (this.browserSupportsPermissionsAPI) {
        const that = this;
        navigator.permissions
          .query({ name: "notifications" })
          .then(function (permissionStatus) {
            permissionStatus.onchange = function () {
              that.onPermissionsChange(this.state);
            };
          });
      }
    },

    onPermissionsChange(newState) {
      // Remove the explanation message, but leave it when permission was denied
      if (newState === "granted") {
        this.settings.showNotifications = true;
        this.notificationPermissionIsVisible = false;
        this.notificationPermissionWhenDeniedIsVisible = false;
        _paq.push(["trackEvent", "Onboarding", "Allowed permissions"]);
      } else {
        this.settings.showNotifications = false;
        _paq.push(["trackEvent", "Onboarding", "Did not allow permissions"]);
      }
    },
  },

  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        // to prevent an infinite loop
        this.$router.replace({ query: from.query }); // Make URL query persistent
      }
    },

    settings: {
      handler: function (newVal) {
        localStorage.setItem("settings", JSON.stringify(newVal));
      },
      deep: true, // Watch the properties nested in the object
    },

    states: {
      handler: function (newVal) {
        localStorage.setItem("states", JSON.stringify(newVal));
      },
      deep: true, // Watch the properties nested in the object
    },

    visibleTray(newVal) {
      if (newVal === "preferences") {
        this.notificationPermissionIsVisible = false;
        if (this.browserNotificationPermissionStatus() !== "granted") {
          // Assume that notifications cannot be shown and the settings should be off
          this.settings.showNotifications = false;
        }
      }

      this.interactionDetected("short", true);
    },

    "settings.showNotifications": {
      handler: function (newVal) {
        if (newVal) {
          if (this.browserNotificationPermissionStatus() !== "granted") {
            this.requestNotificationPermission(false);

            // Turn setting off when not allowed by browser.
            // Needs the delay because of syncing of the properties between parent/child.
            // That also looks better because of toggle animation.
            setTimeout(() => {
              this.settings.showNotifications = false;
            }, 300);
          }
        }
      },
    },

    notificationPermissionWhenDeniedIsVisible(newVal) {
      if (newVal) this.notificationPermissionIsVisible = false;
      else this.settings.showNotifications = false;
    },
  },
};
</script>

<style lang="scss">
@import "./style/abstracts/functions.scss";
@import "./style/abstracts/mixins.scss";
@import "./style/abstracts/variables.scss";

@import "./style/components/BaseTypography.scss";

@import "./style/components/BaseButtons.scss";

@import "./style/components/InteractiveListItem.scss";

@import "./style/components/BaseForms.scss";
@import "./style/components/BaseSwitch.scss";

@import "./style/components/BaseOverlay.scss";
@import "./style/components/BaseCard.scss";

// Make it fit well on windows mobile phones
@-ms-viewport {
  width: device-width;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

html {
  min-height: 100%; // height: 100% isn't really 100% on iOS
  font-size: 62.5%;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  background-color: $color-very-dark;
  overflow: hidden; // Avoid overscrolling in Safari. Only works if content < viewport.
}

body {
  height: 100%;
  margin: 0;
  scroll-behavior: smooth;
  overflow-y: auto;
}

// Avoid bouncy scrolling on iOS Safari - Doesn't work in fullscreen mode :(
html,
body {
  @media screen and (min-height: 460px) {
    position: fixed;
    overflow: hidden;
  }
}
.app {
  display: block;
  min-height: 100%;
  height: auto;
}

// Hide stuff that depends on Vue untill scripts are loaded
[v-cloak] {
  display: none;
}

.main-container {
  height: 100vh;
  min-height: 7 * $button-size-small-screen + rem;

  .with-motion & {
    transform: scale(1);
    transition: transform $duration-medium + ms $ease-in-out-main;
  }
  &.subdued {
    .with-motion & {
      transform: scale(0.9);
      transition: transform $duration-very-long + ms $ease-out-expo;
    }
  }
  &.with-intro-transition {
    .with-motion & {
      transition: transform $duration-very-very-long + ms $ease-out-expo;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "./style/abstracts/functions.scss";
@import "./style/abstracts/mixins.scss";
@import "./style/abstracts/variables.scss";

.with-motion {
  .screensaver-enter {
    opacity: 0;
  }
  .screensaver-enter-active {
    transition-property: opacity;
    transition-duration: $duration-very-long + ms;
    transition-timing-function: $ease-out-expo;
  }
  .screensaver-enter-to {
    opacity: 1;
  }
  .screensaver-leave {
    opacity: 1;
    transform: scale(1);
  }
  .screensaver-leave-active {
    transition-property: opacity, transform;
    transition-duration: $duration-medium + ms;
    transition-timing-function: $ease-in-out-main;
  }
  .screensaver-leave-to {
    opacity: 0;
    transform: scale(1.5);
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue